module.exports = __webpack_public_path__ + "img/YT.55df0a2e.svg";